import React from 'react'
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark justify-content-center w-100 py-2">
        <Link to="/" className="navbar-brand ml-5">
          <span class="d-flex align-items-center navbar-brand">
            <h1><i class="fa-brands fa-react"></i>&nbsp;Crud React App</h1>
          </span>
        </Link>
    </nav>
  )
}

export default Navbar